import { render, staticRenderFns } from "./AddPaymentType.vue?vue&type=template&id=29fbc363&"
import script from "./AddPaymentType.vue?vue&type=script&lang=js&"
export * from "./AddPaymentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports